function WorkshopGallery(){

    this.build();

}

WorkshopGallery.prototype.build = function(){

    let that = this;

    const gelleryItems = document.querySelectorAll(".workshop-link-gallery");
    gelleryItems.forEach(item => {
        item.addEventListener("click", that.constructGallery.bind(this));
    });

};


WorkshopGallery.prototype.constructGallery = function(e){

    let that = this;

    that.gallery_container_titles = $('<div class="gallery-slick-titles"></div>');
    that.gallery_container_images = $('<div class="gallery-slick"></div>');
    that.gallery_container_dots = $('<ul class="gallery-dots"></ul>');

    this.target = e.currentTarget;
    this.images = $(e.currentTarget).find(".workshop-images-gallery");
    this.imagesLength = this.images.length;
    this.imagesLoaded = 0;

    gallery.arrows = (this.imagesLength > 1) ? true : false;
    gallery.construct();

    gallery.containerMiddleTop.append( that.gallery_container_titles );
    gallery.containerMiddleCenter.append( that.gallery_container_images );
    gallery.containerMiddleBottom.append( that.gallery_container_dots );

    that.gallery_container_images.on("beforeChange", function(event, slick, currentSlide, nextSlide){
        that.gallery_container_dots.find('li.current').removeClass('current');
        that.gallery_container_dots.find('li:eq('+nextSlide+')').addClass('current');
    }).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.gallery-slick-titles'
    });

    that.gallery_container_titles.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true
    });

    $(window).on('overlayDone', function() {
        that.loadImage(that.images[that.imagesLoaded]);
    });

};

WorkshopGallery.prototype.loadImage = function(image){

    let that = this;

    let src = $(image).data('workshop-images-gallery');
    let title = $(image).data('workshop-images-title');

    let imageHtml = "<img src='"+ src +"'>";
    let img = $(imageHtml);
    img.on('load', function(){

        that.gallery_container_images.slick('slickAdd', '<div><div class="workshop-slide"><div class="workshop-slide-image">'+ imageHtml +'</div></div></div>');
        that.gallery_container_titles.slick('slickAdd', '<div><div class="workshop-slide-title"><span class="title-lev2 text-center">'+ title +'</span></div></div>');

        let dot = $('<li class="overlay-slider__dot"></li>');
        if( that.imagesLoaded === 0 ) dot.addClass('current');
        that.gallery_container_dots.append( dot );

        if( that.imagesLoaded < that.imagesLength - 1 ){
            that.imagesLoaded++;
            that.loadImage( that.images[ that.imagesLoaded ] );
        }else{
            that.initGallery();
        }

    }).attr("src", src);

};

WorkshopGallery.prototype.initGallery = function(){

    let that = this;
    gallery.initAnimation();

    gallery.navigationNext.on("click", function(){
        that.gallery_container_images.slick('slickNext');
    });

    gallery.navigationPrev.on("click", function(){
        that.gallery_container_images.slick('slickPrev');
    });

    this.gallery_container_dots.find('li').on("click", function(){
        that.gallery_container_images.slick('slickGoTo', $(this).index());
    });

    gallery.close.on('click', function(){
        that.deleteGallery();
    });

    const sliderItems = document.querySelectorAll(".overlay-slider__dot");
    sliderItems.forEach(item => {
        item.addEventListener("mouseenter", mouseAnimation.sliderMouseEnter.bind(mouseAnimation));
        item.addEventListener("mouseleave", mouseAnimation.mouseLeave.bind(mouseAnimation));
    });

};

WorkshopGallery.prototype.deleteGallery = function(){

    let that = this;
    gsap.to( that.gallery_container_images, 0.6, {
        opacity: 0,
        onComplete: function(){
            that.gallery_container_images.slick('slickRemove', null, null, true);
            that.gallery_container_images.slick('unslick');
            that.gallery_container_images.remove();
            gallery.destroy();
        }
    });

};
